import React from "react";
import PropTypes from 'prop-types';
import { Tooltip, Select } from "antd";
import { PlusCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Document, Page } from 'react-pdf/dist/entry.webpack';
import { Api } from '../../../lib/api';

import { CustomField } from '../components/CustomField';

import '@ant-design/compatible/assets/index.css';
import './LabelPage.scss';

const { Option, OptGroup } = Select;

export class LabelPage extends React.Component {
    static propTypes = {
        wizard: PropTypes.object,
        updateWizardData: PropTypes.func
    };

    async selectLabel(value) {
        this.props.updateWizardData({ label: value });
        if (value === null) { return; }
        try {
            await Api.getLabelPdf(value).then((x) => {
                this.props.updateWizardData({ tempUrl: x });
            });
        } catch (e) {
            console.error(e);
        }
    }

    async selectExcelLabel(value, specifiedExportedLabel) {
        if (specifiedExportedLabel === 1) {
            this.props.updateWizardData({ excelLabel: value });
        } else {
            this.props.updateWizardData({ secondExcelLabel: value });
        }
    }

    render() {
        return (
            <div className="page label-page">
                <div>
                    <div className="title">Custom Fields:</div>
                    {!this.props.wizard.validation.fields.customField && (
                        <div className='text-red'>Please select a custom field </div>
                    )}
                    <div className="custom-field-list section">
                        {this.props.wizard.customFields.map((value, index) => (
                            <CustomField
                                key={index + '-' + value.id}
                                selectedId={value}
                                autoIncrement={value?.autoIncrement ?? false}
                                autoClear={value?.autoClear ?? false}
                                userInput={this.props.wizard.ilComp.userInput}
                                required={value.required}
                                allCustomFields={this.props.wizard.allCustomFields}
                                selectedCustomFields={this.props.wizard.customFields}
                                setAuto={(auto, type) => {
                                    let fields = [...this.props.wizard.customFields];
                                    if (type === 1) {
                                        fields[index] = {
                                            ...this.props.wizard.customFields[index],
                                            autoClear: auto
                                        };
                                    } else {
                                        fields[index] = {
                                            ...this.props.wizard.customFields[index],
                                            autoIncrement: auto
                                        };
                                    }
                                    this.props.updateWizardData({ customFields: fields });
                                }}
                                setSelected={(id, customFieldEntry, name) => {
                                    let allfields = { ...this.props.wizard.allCustomFields };
                                    let fields = [...this.props.wizard.customFields];

                                    if (customFieldEntry !== null && customFieldEntry.id !== null && customFieldEntry.id !== undefined && this.props.wizard.customFields.includes(customFieldEntry)) {
                                        allfields[customFieldEntry.id] = {
                                            id: customFieldEntry.id,
                                            name: customFieldEntry.name
                                        };
                                    }

                                    fields[index] = {
                                        ...this.props.wizard.customFields[index],
                                        id: id,
                                        name: name,
                                    };

                                    if (id) {
                                        delete allfields[id];
                                    }

                                    this.props.updateWizardData({
                                        customFields: fields,
                                        allCustomFields: allfields
                                    });
                                }}
                                setRequired={(required) => {
                                    let fields = [...this.props.wizard.customFields];
                                    fields[index] = {
                                        ...this.props.wizard.customFields[index],
                                        required: required
                                    };
                                    this.props.updateWizardData({ customFields: fields });
                                }}
                                delete={() => {
                                    let fields = [...this.props.wizard.customFields];
                                    let allfields = { ...this.props.wizard.allCustomFields };

                                    if (value.name !== undefined) {
                                        let custom = { id: value.id, name: value.name };
                                        allfields[value.id] = custom;
                                    }
                                    fields.splice(index, 1);
                                    this.props.updateWizardData({ customFields: fields, allCustomFields: allfields });
                                }}
                            />
                        ))}
                        <div
                            className="icon"
                            onClick={() =>
                                this.props.updateWizardData({
                                    customFields: [...this.props.wizard.customFields, { required: true }]
                                })
                            }
                        >
                            <PlusCircleOutlined />
                        </div>
                    </div>
                </div>
                <div className="section">
                    <div className="title">
                        Printed Label:{' '}
                        <Tooltip placement="right" title="Printed label">
                            <QuestionCircleOutlined className='text-blue' />
                        </Tooltip>
                    </div>
                    <Select defaultValue={this.props.wizard.label} onChange={(value) => this.selectLabel(value)}>
                        <Option key={null} value={null}>
                            None
                        </Option>
                        {Object.values(this.props.wizard.allLabels).map((label) => (
                            <Option key={label.id} value={label.id}>
                                {label.name}
                            </Option>
                        ))}
                    </Select>
                </div>
                <div className="section">
                    <div className="title">
                        Exported Label:{' '}
                        <Tooltip placement="right" title="Exported label">
                            <QuestionCircleOutlined className='text-blue' />
                        </Tooltip>
                    </div>
                    <Select
                        defaultValue={this.props.wizard.excelLabel}
                        onChange={(value) => this.selectExcelLabel(value, 1)}
                    >
                        <Option key={null} value={null}>
                            None
                        </Option>
                        {Object.values(this.props.wizard.allLabels).map((label) => (
                            <Option key={label.id} value={label.id}>
                                {label.name}
                            </Option>
                        ))}
                        <OptGroup label="Excel Labels">
                            {Object.values(this.props.wizard.allExcelLabels).map((label, index) => (
                                <Option key={index} value={label}>
                                    {label}
                                </Option>
                            ))}
                        </OptGroup>
                    </Select>
                </div>
                <div className="section">
                    <div className="title">
                        Second Exported Label:{' '}
                        <Tooltip placement="right" title="Second exported label">
                            <QuestionCircleOutlined className='text-blue' />
                        </Tooltip>
                    </div>
                    <Select
                        defaultValue={this.props.wizard.secondExcelLabel}
                        onChange={(value) => this.selectExcelLabel(value, 2)}
                    >
                        <Option key={null} value={null}>
                            None
                        </Option>
                        {Object.values(this.props.wizard.allLabels).map((label) => (
                            <Option key={label.id} value={label.id}>
                                {label.name}
                            </Option>
                        ))}
                        <OptGroup label="Excel Labels">
                            {Object.values(this.props.wizard.allExcelLabels).map((label, index) => (
                                <Option key={index} value={label}>
                                    {label}
                                </Option>
                            ))}
                        </OptGroup>
                    </Select>
                </div>
                {this.props.wizard.tempUrl && this.props.wizard.label && (
                    <React.Fragment>
                        {' '}
                        <div>Label Preview (Printed Label) </div>
                        <div className='border-solid'>
                            <Document file={this.props.wizard.tempUrl} onLoadError={(err) => { }}>
                                <Page pageNumber={1} width={600} />
                            </Document>
                        </div>
                    </React.Fragment>
                )}
            </div>
        );
    }
}